import { bindDraftStoreToSession, createChunkRecovery, createDraftStore, createPendingSourceRegistry } from '@mbbe/config';
import { isOpsHost } from '../ops/isOpsHost';
import { isPortalHost } from '../portal/isPortalHost';
import { customerSession, opsSession } from './sessions';

/** Mutation activity of the app's QueryClient(s); it outlives the screens that started the mutations. */
export const mainMutationActivity = createPendingSourceRegistry();

/**
 * Stale-deployment recovery shared by the public site, Ops and the customer portal
 * (see @mbbe/config chunkRecovery). Each host serves exactly one surface, so the draft
 * owner is the uid of that surface's session.
 */
export const mainRecovery = createChunkRecovery({ namespace: 'mbbe-main', pendingSource: mainMutationActivity });
export const mainDrafts = createDraftStore({
  namespace: 'mbbe-main',
  getUid: () => (isOpsHost() ? opsSession.current.uid : isPortalHost() ? customerSession.current.uid : null),
});

// A draft never outlives the account that wrote it: sign-out or an account switch removes it.
bindDraftStoreToSession(opsSession, mainDrafts);
bindDraftStoreToSession(customerSession, mainDrafts);
